
import { ApiService } from "./apiService";
import { AttachmentRequest, DocumnetUploadStatus, KernelUploadSuccess, UploadRequest } from "../common/document.model";

export class DocumentService {
    private api: ApiService;

    constructor(apiService: ApiService) {
        this.api = apiService;
    }
    
    // Kernel Saving
    async uploadDocument(file: File, abortSignal: AbortSignal): Promise<KernelUploadSuccess> {
        return this.api.upload<KernelUploadSuccess>('/km/upload', [file], abortSignal);
    }
 // file serverside multifile upload
    async uploadDocuments(files: File[], abortSignal: AbortSignal): Promise<KernelUploadSuccess> {
        return this.api.upload<KernelUploadSuccess>('/uploads', files, abortSignal);
    }
    async getDocumentStatus(documentId: string, abortSignal: AbortSignal): Promise<DocumnetUploadStatus> {
        return this.api.get(`/km/upload-status?documentId=${documentId}`, abortSignal);
    }

    // Internal API saving
    async uploadAttachmentToServer(payload: AttachmentRequest, abortSignal: AbortSignal): Promise<Response> {
        return this.api.put2('/attachment', abortSignal, payload);
    }
}